export default __webpack_public_path__ + "6f7b47e04cd494f46ee8a9d59b3b9bce.svg";